import React from "react";
import styled from "@emotion/styled";
import Text from "../global/Text";
import { EaselButton } from "../global/EaselButton";

export interface StudentContentViolationScreenProps {
  closeButtonText: string;
  backgroundColor: string;
  onClose: () => void;
  contentType: "activity" | "assessment";
}

export const StudentContentViolationScreen: React.FC<StudentContentViolationScreenProps> =
  ({ backgroundColor, contentType, closeButtonText, onClose }) => (
    <Container background={backgroundColor}>
      <Text variant="h5" strong>
        Uh oh.
      </Text>

      <TextWrapper>
        {contentType === "activity" ? (
          <Text>We’re sorry! This activity has been removed from Easel.</Text>
        ) : (
          <Text>We’re sorry! We can’t open this resource right now.</Text>
        )}
      </TextWrapper>

      <ButtonWrapper>
        <EaselButton variant="secondary" onClick={onClose}>
          {closeButtonText}
        </EaselButton>
      </ButtonWrapper>
    </Container>
  );

const ButtonWrapper = styled.div();
const TextWrapper = styled.div({
  marginTop: "0.75rem",
  marginBottom: "1.5rem",
});
const Container = styled.div<{ background: string }>((props) => ({
  padding: "2rem",
  display: "flex",
  flexDirection: "column",
  flex: 1,
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: props.background,
}));
